(function ($) {
    $(document).ready(function () {

        const interval = setInterval(() => {
            if ($('.patient-diet__posts').hasClass('swiper-initialized')) {
                bindEvents();
                clearInterval(interval)
            }
        }, 50);
    })

    $(document).on("keydown", (event) => {
        if (event.key === "Escape" || event.keyCode === 27) {
            closeModal();
        }
    });

    $('.modal-close').on('click', closeModal);

    $('#patients-diets-modal .modal-wrapper').on('click', () => {
        closeModal();
    });

    $('#patients-diets-modal .modal').on('click', (e) => {
        e.stopPropagation();
    });

    function closeModal() {
        $('#patients-diets-modal').fadeOut(300);
        $('body').css('overflow', 'auto');
    }

    function bindEvents() {
        $('.patients-diets .item .details__read-more').on('click', function () {

            const $parent = $(this).parents('.item');

            $('#patients-diets-modal .modal-content').html($parent.data('modal-content'));
            $('#patients-diets-modal').fadeIn(300);
            $('body').css('overflow', 'hidden');

            initSlick();
        });
    }

        window.$ = jQuery;
        const SELECTOR_SLICK = '.patient-diet-meals-images';
        const $modalContent = $('#patients-diets-modal .modal-content');
        const SETTINGS_SLICK = {
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            arrows: true,
            autoplay: false,
            appendArrows: $modalContent,
            appendDots: $modalContent,
        };

        const initSlick = () => {
            const element = $(SELECTOR_SLICK);
            element.slick(SETTINGS_SLICK);
        };

})(jQuery);